import React from 'react'

import s from './CollectionsCreate.module.css'
import image from './collectionImage.png'

function CollectionsCreate({ onCreate }) {
  return (
    <div className={s.root}>
      <div className={s.imageWithLabel}>
        <div className={s.imageWrapper}>
          <img src={image} className={s.image} alt="collection" />
        </div>
        Create a New Collection
      </div>
      <button type="button" className={s.button} onClick={() => onCreate()}>
        Create Collection
      </button>
    </div>
  )
}

export default CollectionsCreate
